import React from 'react';
import { translate } from '../../../i18n/I18nProvider';
import capitaliseFirstLetter from '../../../utils/capitaliseFirstLetter';
import { formatDateForSchedule } from '../../../utils/formatDate';
import { isUndefined } from '../../../utils/isDefined';
import Optional from '../../../utils/optional';
import AccountCell from './AccountCell';
import { findSkuTranslation } from '../actions/customSearchActions';
import searchCaseInsensitive from '../../../utils/searchCaseInsensitive';
import ProductCell from './ProductCell';

const tableColumns = ({ lang, showAll }) => {
  const columns = [
    {
      title: 'TABLE.NAME',
      field: 'name'
    },
    {
      title: capitaliseFirstLetter(translate('SUBSCRIPTIONS.GROUP_BY_SKU')),
      untranslatedTitle: 'true',
      field: 'skuTranslations',
      render: rowData => <ProductCell rowData={rowData} lang={lang} />,
      customFilterAndSearch: (term, rowData) => {
        return searchCaseInsensitive(
          findSkuTranslation({ rowData, lang }),
          term
        );
      },
      exportTransformer: rowData => findSkuTranslation({ rowData, lang })
    },
    {
      title: 'USER.LOCATION',
      field: 'user'
    },
    {
      title: 'ACCOUNT',
      field: 'accountName',
      hideWhenAccountSelected: true,
      render: rowData => <AccountCell data={rowData} />
    },
    {
      title: 'ACTIVATION_DATE',
      field: 'activationDate',
      hidden: true,
      render: rowData => {
        return Optional(formatDateForSchedule(rowData.activationDate)).or('-');
      }
    },
    {
      title: 'EXPIRE_DATE',
      field: 'expiryDate',
      hidden: true,
      render: rowData => {
        return Optional(formatDateForSchedule(rowData.expiryDate)).or('-');
      }
    }
  ];

  let mappedColumns = [...columns];

  if (!showAll) {
    mappedColumns = mappedColumns.filter(column =>
      isUndefined(column.hideWhenAccountSelected)
    );
  }

  return mappedColumns.map((column, i) => {
    return { ...column, id: i };
  });
};

export default tableColumns;
